import { connect } from 'react-redux'

import { setActiveProperty, toggleWishlist } from '../redux/modules/search/actions'

import SearchResults from '../components/SearchResults'

const mapStateToProps = (state) => ({
  eventCity: state.search.eventCity,
  results: state.search.results,
  pricesForBookedAccommodations: state.search.prices_for_booked_accommodations,
  bookingIdsForBookedAccommodations: state.search.booking_ids_for_booked_accommodations,
  wishlistOrderAccIdsForBookedAccommodations: state.search.wishlist_order_accommodation_ids_for_booked_accommodations

})

const actionCreators = { setActiveProperty, toggleWishlist }

export default connect(mapStateToProps, actionCreators)(SearchResults)



// WEBPACK FOOTER //
// ./src/containers/SearchResults.js